import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { IncrediField } from 'incredi-ui';
import { onMounted, ref, watch, nextTick } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
    error: { type: Boolean },
    errorMessage: null,
    ghost: { type: Boolean },
    inputText: null,
    maxInputLength: null,
    minInputLength: { default: 1 }
  },
  emits: ["update:input", "clear:input", "focusWithin", "blurWithin"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update:input', description: string): void;
  (e: 'clear:input'): void;
  (e: 'focusWithin'): void;
  (e: 'blurWithin'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { error?: boolean, errorMessage?: string, ghost: boolean, inputText: string, maxInputLength?: number, minInputLength: number }


const localValue = ref('');
const loading = ref(false);
const inputRef = ref<any>();
onMounted(() => {
  if (!localValue.value) inputRef?.value?.focusInput();
});
watch(
  () => props.inputText,
  curr => {
    localValue.value = curr;
  },
  { immediate: true },
);

// eslint-disable-next-line no-unused-vars


const handleBlur = async (isEsc: boolean | false | undefined) => {
  emit('blurWithin');
  if (loading.value) return;
  loading.value = true;
  if (localValue.value.length < props.minInputLength || isEsc) {
    localValue.value = props.inputText;
    emit('clear:input');

    loading.value = false;
    return;
  }
  if (localValue.value === props.inputText || !localValue.value.trim()) {
    localValue.value = props.inputText;
    emit('clear:input');

    loading.value = false;
    return;
  }

  emit('update:input', localValue.value.replace(/\s+/g, ' ').trim());
  await nextTick();

  loading.value = false;
};

const handleClear = async () => {
  localValue.value = '';
  inputRef?.value?.focusInput();
};

const reset = () => {
  localValue.value = props.inputText;
};

expose({ inputRef, reset });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_unref(IncrediField), {
        key: Number(loading.value),
        modelValue: localValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
        clearable: "",
        ref_key: "inputRef",
        ref: inputRef,
        name: "description",
        size: "tiny",
        "field-type": "text",
        maxlength: __props.maxInputLength,
        ghost: __props.ghost,
        class: "m-1",
        error: __props.error,
        "error-message": __props.errorMessage,
        onBlurWithin: _cache[1] || (_cache[1] = () => handleBlur(false)),
        onFocusWithin: _cache[2] || (_cache[2] = () => emit('focusWithin')),
        onClear: handleClear,
        onKeydown: [
          _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => handleBlur(false), ["stop","prevent"]), ["enter"])),
          _cache[4] || (_cache[4] = _withKeys(() => handleBlur(true), ["esc"]))
        ]
      }, null, 8, ["modelValue", "maxlength", "ghost", "error", "error-message"]))
    ]),
    _: 1
  }))
}
}

})